export type Role = "carrier" | "broker" | "shipper";

export type SubscriptionPlanType = "annually" | "monthly" | "bi-annual";

export type SubscriptionPlan = Partial<Record<SubscriptionPlanType, PlanDetails>>;

export type ProductCatalog = Record<Role, SubscriptionPlan>;

export function isSubscriptionPlanType(plan: any): plan is SubscriptionPlanType {
  if (plan) {
    // Search the list case-insensitive
    return ["annually", "monthly", "bi-annual"].includes(plan.toLowerCase());
  } else {
    return plan;
  }
}

export interface PlanDetails {
  planLabelOther: string;
  planPrice: string;
  planPriceByYear: string;
  planPriceByMonth: string;
  planKey: string;
  planLabel: string;
  planPriceType: string;
}

export const subscriptionPlans: Record<Role, Record<SubscriptionPlanType, PlanDetails>> = {
  carrier: {
    annually: {
      planLabelOther: "12-Month",
      planPrice: "500.00",
      planPriceByYear: "$500.00",
      planPriceByMonth: "$41.66",
      planKey: "rtlb_carrier_annual",
      planLabel: "$500 Billed Annually",
      planPriceType: "Billed Annually"
    },
    monthly: {
      planLabelOther: "1-Month",
      planPrice: "49.00",
      planPriceByYear: "$588.00",
      planPriceByMonth: "$49.00",
      planKey: "rtlb_carrier_monthly",
      planLabel: "Billed Monthly",
      planPriceType: "Billed Monthly"
    },
    "bi-annual": {
      planLabelOther: "6-Month",
      planPrice: "275.00",
      planPriceByYear: "$550.00",
      planPriceByMonth: "$45.83",
      planKey: "rtlb_carrier_semi_annual",
      planLabel: "$275 Billed Bi-Annually",
      planPriceType: "Billed Bi-Annually"
    }
  },
  broker: {
    annually: {
      planLabelOther: "12-Month",
      planPrice: "750.00",
      planPriceByYear: "$750.00",
      planPriceByMonth: "$62.50",
      planKey: "rtlb_broker_annual",
      planLabel: "$750 Billed Annually",
      planPriceType: "Billed Annually"
    },
    monthly: {
      planLabelOther: "1-Month",
      planPrice: "75.00",
      planPriceByYear: "$900.00",
      planPriceByMonth: "$75.00",
      planKey: "rtlb_broker_monthly",
      planLabel: "Billed Monthly",
      planPriceType: "Billed Monthly"
    },
    "bi-annual": {
      planLabelOther: "6-Month",
      planPrice: "395.00",
      planPriceByYear: "$790.00",
      planPriceByMonth: "$65.83",
      planKey: "rtlb_broker_semi_annual",
      planLabel: "$395 Billed Bi-Annually",
      planPriceType: "Billed Bi-Annually"
    }
  },
  shipper: {
    annually: {
      planLabelOther: "12-Month",
      planPrice: "500.00",
      planPriceByYear: "$500.00",
      planPriceByMonth: "$41.66",
      planKey: "rtlb_shipper_annual",
      planLabel: "$500 Billed Annually",
      planPriceType: "Billed Annually"
    },
    monthly: {
      planLabelOther: "1-Month",
      planPrice: "49.00",
      planPriceByYear: "$588.00",
      planPriceByMonth: "$49.00",
      planKey: "rtlb_shipper_monthly",
      planLabel: "Billed Monthly",
      planPriceType: "Billed Monthly"
    },
    "bi-annual": {
      planLabelOther: "6-Month",
      planPrice: "275.00",
      planPriceByYear: "$550.00",
      planPriceByMonth: "$45.83",
      planKey: "rtlb_shipper_semi_annual",
      planLabel: "$275 Billed Bi-Annually",
      planPriceType: "Billed Bi-Annually"
    }
  }
};

export function getUserRole(
  isCarrier: boolean,
  isBroker: boolean,
  isShipper: boolean
): Role | null {
  if (isCarrier) return "carrier";
  if (isBroker) return "broker";
  if (isShipper) return "shipper";
  return null;
}

export function getPlanDetails(
  isCarrier: boolean,
  isBroker: boolean,
  isShipper: boolean,
  subscriptionPlanType: SubscriptionPlanType
): PlanDetails {
  const role = getUserRole(isCarrier, isBroker, isShipper);

  if (role && subscriptionPlans[role][subscriptionPlanType]) {
    return subscriptionPlans[role][subscriptionPlanType];
  }

  return {
    planLabelOther: "N/A",
    planPrice: "N/A",
    planPriceByMonth: "N/A",
    planPriceByYear: "N/A",
    planKey: "N/A",
    planLabel: "N/A",
    planPriceType: "N/A"
  };
}
